import createSuccessPromiseThunk from "~/rx/lib/createSuccessPromiseThunk";
import passwordApi from "~/backend/passwordApi";



const { reduce, execute, types, } = createSuccessPromiseThunk({
    func: async ({username, getConfig, getTranslator}) => {
        if (!username) {
            const trans = getTranslator();
            return { friendly_error: trans("forgotPasswordPage.noCredentials") };
        }
        return passwordApi.resetPassword(getConfig().baseUrl, username);
    },
    name: 'requestResetPasswordLink',
    successHandler: ({value, dispatch, setValue, setErrored, customParams, getTranslator}) => {
        if (!!value.success) {
            dispatch(setValue(value, customParams));
            return true;
        }

        dispatch(setErrored(value.friendly_error, customParams));
        return true;
    }
});

export { types as AUTH_TYPES, reduce as reduceResetPasswordLink, execute as requestResetPasswordLink };
